import * as React from 'react';

const AlternateLearnerOnConsumerMobileMainNav = () => {
  return <div>AlternateLearnerOnConsumerMobileMainNav</div>;
};

export default AlternateLearnerOnConsumerMobileMainNav;
